import type { ReactElement } from 'react';

import { IFRAME_TYPE } from '@pp/core/src/store/slices/launcher/types';
import { useModifiers } from '@pp/core/src/styles/hooks/useModifiers';

import { LauncherTableInfo } from '../../context/types';
import { Close } from '../close/Close';

import styles from './Table.module.css';

interface TableProps {
  table: LauncherTableInfo;
  isMobile: boolean;
  tablesCount: number;
  onTableClose: (tableId: string) => void;
  hasMTB: boolean;
}

export const Table = ({ table, isMobile, tablesCount, hasMTB, onTableClose }: TableProps): ReactElement => {
  const isMTBFrame = table.iframeType === IFRAME_TYPE.MTB;
  const isLobbyFrame = table.iframeType === IFRAME_TYPE.LOBBY;
  const tableMods = useModifiers(
    styles,
    'table',
    {
      isScale: tablesCount > 1 && !hasMTB,
      isTwoTables: tablesCount === 2 && !hasMTB,
      mtb: isMTBFrame,
      lobby: isLobbyFrame && tablesCount > 1,
      isMobile,
    },
    {
      withBaseClass: true,
    }
  );

  const frameMods = useModifiers(
    styles,
    'table__frame',
    {
      isActive: tablesCount > 1 && table.isActive && !hasMTB,
    },
    { withBaseClass: true }
  );

  return (
    <div className={`${tableMods} table`} key={table.tableId}>
      {tablesCount > 1 && table.showClose && <Close close={() => onTableClose(table.tableId)} table={table} />}
      <iframe
        name={`launcher-${table.tableId}`}
        src={table.url}
        className={frameMods}
        id={table.tableId}
        allowFullScreen
        style={{ background: '#000000' }}
      />
    </div>
  );
};
